import React from 'react';
// import { motion } from 'framer-motion'; // Temporarily commented out
import ProjectCard from '../ProjectCard';
import './Projects.css';

const Projects = ({ projects }) => {
  return (
    <section // Reverted to plain section
      id="projects"
      // initial="hidden" // Temporarily commented out
      // whileInView="visible" // Temporarily commented out
      // viewport={{ once: true }} // Temporarily commented out
      // variants={sectionVariants} // Temporarily commented out
    >
      <h2>My Projects</h2>
      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id}>
            <ProjectCard project={project} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
